@import ../../styles/helpers

.container
    width: 100%
    display: flex
    flex-direction: column

.title
    margin-bottom: 24px
    line-height: 1.4
    font-size: 52px
    margin-top: 40px
    +m
        font-size: 45px